import * as Yup from 'yup';
import { phoneRegex } from "helpers/helpers";

export const getValidationSchema = (intl) =>
    Yup.object().shape({
        name: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        ico: Yup.number()
            .required(intl.formatMessage({ id: 'validation.required' }))
            .typeError(intl.formatMessage({ id: 'validation.number' }))
            .nullable(),
        postal: Yup.string()
            .matches(/^[0-9]+$/, intl.formatMessage({ id: 'validation.number' }))
            .min(5, intl.formatMessage({ id: 'validation.string.exact' }, [5]))
            .max(5, intl.formatMessage({ id: 'validation.string.exact' }, [5]))
            .nullable(),
        contactFirstName: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        contactLastName: Yup.string().required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        contactEmail: Yup.string()
            .email(intl.formatMessage({ id: 'validation.email' }))
            .required(intl.formatMessage({ id: 'validation.required' })).nullable(),
        contactPhone: Yup.string()
            .matches(phoneRegex, intl.formatMessage({ id: 'validation.phoneNumber' }))
            .matches(/^[+,0-9]+$/, intl.formatMessage({ id: 'validation.phoneNumber' }))
            .nullable(),
    });

export default getValidationSchema;